import { memo } from 'react';
import { Box } from '@mui/material';
import { formatTime } from '@utils/time/timeUtils';
import TranscriptWord from './TranscriptWord';

function TranscriptSegment({
  segment,
  isActive,
  activeWord,
  onTimestampClick,
  onWordClick
}) {
  const hasWords = segment.words && segment.words.length > 0;

  return (
    <>
      <Box
        component="button"
        type="button"
        aria-label={`Jump to ${formatTime(segment.start)}`}
        aria-current={isActive ? 'time' : undefined}
        onClick={() => onTimestampClick(segment.start)}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          verticalAlign: 'baseline',
          px: 0.7,
          py: 0.15,
          mr: 0.7,
          minHeight: 24,
          border: 1,
          borderColor: isActive ? 'primary.main' : 'divider',
          borderRadius: 1,
          bgcolor: isActive ? 'primary.main' : 'action.hover',
          color: isActive ? 'primary.contrastText' : 'text.secondary',
          cursor: 'pointer',
          fontFamily: 'inherit',
          fontSize: '0.72rem',
          lineHeight: 1.4,
          whiteSpace: 'nowrap',
          '&:hover': {
            borderColor: 'primary.main',
            bgcolor: isActive ? 'primary.dark' : 'action.selected'
          },
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            outlineOffset: 2
          }
        }}
      >
        {formatTime(segment.start)}
      </Box>
      {hasWords ? (
        segment.words.map((word, index) => (
          <TranscriptWord
            key={index}
            word={word}
            isActive={activeWord?.start === word.start}
            onClick={() => onWordClick(word.start)}
          />
        ))
      ) : (
        <Box component="span">
          {segment.text}{' '}
        </Box>
      )}
      {' '}
    </>
  );
}

export default memo(TranscriptSegment);
